<template>
    <main-content-wrapper-big>
        <template v-if="!error">
            <v-tabs fixed-tabs show-arrows v-model="tabs" v-show="!loading">
                <v-tab href="#profil">
                    Profil
                </v-tab>
                <v-tab href="#podatki" v-if="!loading && !connected_account_is_temp">
                    Moji podatki
                </v-tab>
                <v-tab href="#privolitve">
                   Privolitve
                </v-tab>
                <v-tab href="#enovice" v-if="!loading && !connected_account_is_temp">
                    E-novice
                </v-tab>
                <v-tab href="#hitri-nakup" v-if="allowedHN">
                    Hitri nakup
                </v-tab>
                <v-tab href="#varnost">
                    Varnost
                </v-tab>
                <v-tab @click="openTeam" v-if="allowedTusTeam">
                    Kadrovski eportal
                </v-tab>
            </v-tabs>
            <empty-space />
            <v-tabs-items v-model="tabs" v-show="!loading">
                <v-tab-item value="profil">
                    <profile-tab />
                </v-tab-item>
                <v-tab-item value="podatki">
                    <user-data-tab />
                </v-tab-item>
                <v-tab-item value="privolitve">
                    <consents-tab />
                </v-tab-item>
                <v-tab-item value="enovice">
                    <enews-tab />
                </v-tab-item>
                <v-tab-item value="hitri-nakup" v-if="allowedHN">
                    <fast-order-tab v-if="tabs == 'hitri-nakup'" @needReload="reloadPartial" />
                </v-tab-item>
                <v-tab-item value="varnost">
                    <security-tab />
                </v-tab-item>
            </v-tabs-items>
            <div class="loader" v-if="loading">
                <empty-space />
                <v-progress-circular :indeterminate="true" size="50" ></v-progress-circular>
            </div>
        </template>
        <template v-if="error">
            <v-alert
                    :value="true"
                    type="error"
            >
                Pri pridobivanju vaših podatkov je prišlo do napake. Koda napake: {{ error_code }}.
            </v-alert>
            <empty-space />
            <p class="text-sm-center">
                <v-btn depressed @click="reload()" color="primary_action_small">Poskusi ponovno</v-btn>
            </p>
        </template>
    </main-content-wrapper-big>
</template>

<script>
    import MainContentWrapperBig from "../components/MainContentWrapperBig";
    import EmptySpace from "../components/EmptySpace";
    import ProfileTab from "../components/account/ProfileTab";
    import ConsentsTab from "../components/account/ConsentsTab";
    import UserDataTab from "../components/account/UserDataTab";
    import SecurityTab from "../components/account/SecurityTab";
    import utils from "../store/utils";
    import Router from '../router';
    import FastOrderTab from "../components/account/FastOrder";
    import EnewsTab from "../components/account/EnewsTab";

    export default {
        name: "Account",
        data () {
            return {
                tabs: null,
            }
        },
        components: {
            EnewsTab,
            FastOrderTab, UserDataTab, ConsentsTab, MainContentWrapperBig, EmptySpace, ProfileTab, SecurityTab},
        computed: {
            loading: utils.vuexBuildSetGet(this, 'profile', 'loading'),
            error: utils.vuexBuildSetGet(this, 'profile', 'error'),
            error_code: utils.vuexBuildSetGet(this, 'profile', 'error_code'),
            connected_card: utils.vuexBuildSetGet(this, 'profile', 'user.connected_card'),
            connected_account_is_temp: utils.vuexBuildSetGet(this, 'profile', 'user.connected_account_is_temp'),
            needs_password_change: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user.needs_password_change'),
            is_tus_team: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user.is_tus_team'),
            is_tus_team_only: utils.vuexBuildSetGet(this, 'auth', 'authenticated_user.is_tus_team_only'),

            allowedHN() {
                if(this.$store.state.profile.user.apps){
                    for (let app of this.$store.state.profile.user.apps){
                        if (app.type == 'HN'){
                            return true;
                        }
                    }
                }
                return false;
            },
            allowedTusTeam() {
                return this.is_tus_team;
            }
        },
        created() {
            if (this.needs_password_change){
                Router.push('/zahteva-novo-geslo');
            } else if (this.is_tus_team_only){
                Router.push('/team');
            }else {
                this.$store.dispatch('profile/allAboutMe', {validate: true});
            }
        },
        mounted() {
            this.$trackPageVisit('account');
        },
        watch: {
            error_code: function (val) {
                // if (val == 18){
                //     // no connected card or account.
                //     Router.push('/racun/povezi')
                // }
            }
        },
        methods: {
            reload(){
                window.location.replace('/');
            },
            reloadPartial(){
                this.$store.dispatch('profile/allAboutMe');
            },
            openTeam(){
                Router.push('/team');
            }
        }
    }
</script>

<style scoped>
.loader {
    text-align: center;
}


</style>